import type { Components, Theme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { fontFamily } from './typography';

export const buildMuiAutocompleteComponent = (): Components<Omit<Theme, 'components'>>['MuiAutocomplete'] => ({
  styleOverrides: {
    root: {
      fontFamily,
      minHeight: '31px',
      '& > .MuiFormControl-root': {
        margin: 0,
      },
    },
    input: ({ theme }) => ({
      '&.MuiOutlinedInput-input, &.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': { padding: 0 },
      '& .Mui-placeholder': {
        color: theme.palette.primary[60],
        opacity: 1,
        fontWeight: 400,
      },
    }),
    listbox: ({ theme }) => ({
      paddingTop: 0,
      paddingBottom: 0,
      '& .MuiAutocomplete-option': {
        fontFamily,
        fontSize: '11px',
        lineHeight: '150%',
        minHeight: '31px',
        margin: '10px',
        color: theme.palette.primary[80],
        padding: '10px',
        outline: 0,
        borderRadius: '4px',
      },
      '& .MuiAutocomplete-option.Mui-focused': {
        backgroundColor: theme.palette.secondary[10],
      },
      '& .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
        backgroundColor: theme.palette.secondary[30],
      },
    }),
  },
  defaultProps: {
    popupIcon: <KeyboardArrowDownIcon />,
  },
});
